var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReplacement = function SvgReplacement(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_203_2424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4979 18C30.6488 18 14.5 34.1488 14.5 54C14.5 73.8512 30.6488 90 50.4979 90C70.3512 90 86.5 73.8512 86.5 54C86.5 34.1488 70.3512 18 50.4979 18Z",
    fill: "#E9DBBC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 54,
    r: 22,
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4985 29C36.7145 29 25.5 40.2145 25.5 54C25.5 67.7855 36.7145 79 50.4985 79C64.2855 79 75.5 67.7855 75.5 54C75.5 40.2145 64.2855 29 50.4985 29ZM63.3744 59.8646C62.8947 60.9249 62.2775 61.9268 61.5433 62.8452C58.7529 66.3318 54.6345 68.1438 50.4839 68.1438C47.4653 68.1438 44.4292 67.1771 41.8683 65.2013C41.1429 65.5538 40.34 65.7731 39.4815 65.7731C36.46 65.7731 34.0015 63.3147 34.0015 60.2931C34.0015 57.2745 36.46 54.8146 39.4815 54.8146C42.503 54.8146 44.9615 57.2745 44.9615 60.2931C44.9615 61.3666 44.6398 62.364 44.103 63.2108C48.9029 66.5468 55.5529 65.6474 59.2575 61.0171C59.8366 60.2888 60.3251 59.4946 60.7083 58.6537C61.0432 57.9195 61.9046 57.589 62.6446 57.9283C63.3861 58.2617 63.7093 59.129 63.3744 59.8646ZM61.5156 53.1868C58.494 53.1868 56.0341 50.7284 56.0341 47.7069C56.0341 46.6334 56.3573 45.636 56.8941 44.7892C54.6637 43.2374 51.983 42.5413 49.2642 42.844C46.2851 43.1746 43.6131 44.6429 41.7382 46.9844C41.1575 47.7083 40.6691 48.5039 40.2844 49.3463C40.0402 49.8845 39.5078 50.2033 38.9521 50.2033C38.7488 50.2033 38.5455 50.1624 38.3466 50.0717C37.611 49.7368 37.2863 48.871 37.6212 48.1354C38.1053 47.0692 38.7239 46.0674 39.4552 45.1548C41.8157 42.2049 45.1867 40.3519 48.9424 39.9366C52.6118 39.5315 56.2111 40.5523 59.1244 42.8002C59.8498 42.4448 60.6527 42.2269 61.5126 42.2269C64.5342 42.2269 66.9912 44.6853 66.9912 47.7069C66.9912 50.7284 64.5371 53.1868 61.5156 53.1868Z",
    fill: "#E9DBBC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_203_2424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReplacement, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/replacement.2546d167.svg";
export { ForwardRef as ReactComponent };